module.exports = __webpack_public_path__ + "static/media/30300.c87f7183.jpg";